import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import {
  RemoteDiagnosticsControlUnit,
  RemoteDiagnosticsSnapshotsStore,
  RemoteDiagnosticsStore,
  SnapshotType,
  VddDetailsListStore,
} from '@store';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-backup-vdd-table-item',
  templateUrl: './backup-vdd-table-item.component.html',
  styleUrls: ['./backup-vdd-table-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupVddTableItemComponent implements OnInit, OnDestroy {
  readonly snapshotTypeEnum = SnapshotType;

  gatewaySerial: string;
  controlUnits: RemoteDiagnosticsControlUnit[];

  @Input() vddName: string;
  @Input() logicalLink: string;
  @Input() fullWidthMode = false;
  @Input() snapshotType: SnapshotType;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    public vddDetailsListStore: VddDetailsListStore,
    private activatedRoute: ActivatedRoute,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });
    this.remoteDiagnosticsStore
      .getControlUnits(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((controlUnits) => {
        this.controlUnits = controlUnits;
      });
  }

  getFullNameOFControlUnit(controlUnit: string): string {
    let controlUnitDetails;
    if (this.controlUnits?.length) {
      controlUnitDetails = this.controlUnits.find((LL) => LL.value === controlUnit);
    }

    if (controlUnitDetails) {
      return `${this.translate.instant(controlUnitDetails.objectProperty)} ${this.translate.instant(
        controlUnitDetails.busType
      )}: ${controlUnitDetails.busAddress}`;
    } else {
      return controlUnit;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
